import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import commonDe from '@/assets/locales/de.json';
import commonEn from '@/assets/locales/en.json';
import commonEs from '@/assets/locales/es.json';
import commonFr from '@/assets/locales/fr.json';
import commonSv from '@/assets/locales/sv.json';
import coursesDe from '@/features/courses/locales/de.json';
import coursesEn from '@/features/courses/locales/en.json';
import coursesEs from '@/features/courses/locales/es.json';
import coursesFr from '@/features/courses/locales/fr.json';
import coursesSv from '@/features/courses/locales/sv.json';
import navDe from '@/components/layouts/locales/de.json';
import navEn from '@/components/layouts/locales/en.json';
import navEs from '@/components/layouts/locales/es.json';
import navFr from '@/components/layouts/locales/fr.json';
import navSv from '@/components/layouts/locales/sv.json';
import userDe from '@/features/user/locales/de.json';
import userEn from '@/features/user/locales/en.json';
import userEs from '@/features/user/locales/es.json';
import userFr from '@/features/user/locales/fr.json';
import userSv from '@/features/user/locales/sv.json';

export const supportedLanguages = ['fr', 'en', 'de', 'es', 'sv'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageLabels: Record<SupportedLanguage, string> = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  sv: 'Svenska',
};

const resources = {
  en: { common: { ...commonEn, ...coursesEn, ...navEn }, user: userEn },
  fr: { common: { ...commonFr, ...coursesFr, ...navFr }, user: userFr },
  de: { common: { ...commonDe, ...coursesDe, ...navDe }, user: userDe },
  es: { common: { ...commonEs, ...coursesEs, ...navEs }, user: userEs },
  sv: { common: { ...commonSv, ...coursesSv, ...navSv }, user: userSv },
};

await i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    debug: false,
    defaultNS: 'common',
    ns: ['common', 'user'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Server-stored language takes priority (applied after user fetch),
      // then localStorage for unauthenticated / pre-fetch state.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export { default } from 'i18next';
